import { QUERY_PARAMETERS, QUERY_PARAMETERS_TRANSLATIONS } from 'Constants/QueryParameters';

// Detects and returns all params for occupancy
const getOccupancyParams = (queryParams) => {
    const query = {};
    const child = QUERY_PARAMETERS.CHILD_ROOM;
    const childLength = child.length;
    const adult = QUERY_PARAMETERS.ADULT_ROOM;
    const adultLength = adult.length;
    const occupancyParameters = Object.keys(queryParams).filter(
        param => param.substring(0, childLength) === child
            || param.substring(0, adultLength) === adult,
    );
    occupancyParameters.forEach((occupancyParameterName) => {
        query[occupancyParameterName] = queryParams[occupancyParameterName];
    });
    return query;
};

const getQueryString = (params, paramsToDelete = []) => {
    const searchParams = new URLSearchParams();
    Object.entries(params)
        .filter(([ key, value ]) => !paramsToDelete.includes(key) && value)
        .forEach(([ key, value ]) => searchParams.append(key, value));

    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : '';
};

const getCommonParamsForUrlState = (url) => {
    const parameters = { ...url };

    const occupancyParams = getOccupancyParams(parameters);
    Object.keys(occupancyParams).forEach((occupancy) => {
        delete parameters[occupancy];
    });

    Object.keys(QUERY_PARAMETERS_TRANSLATIONS).forEach((paramKey) => {
        const paramData = QUERY_PARAMETERS[paramKey];
        if (typeof parameters[paramData] !== 'undefined' && !paramData.common) {
            delete parameters[paramData];
        }
    });

    return parameters;
};

const getSearchParamsForUrlState = (state, searchParamsHasChanged) => {
    const { language, currency, searchParams, url } = state;

    let query = {};

    const shouldSetUrlParams = (searchParamsHasChanged
        || url[QUERY_PARAMETERS_TRANSLATIONS.CHECKIN]
        || url[QUERY_PARAMETERS_TRANSLATIONS.CHECKOUT]
        || url[QUERY_PARAMETERS_TRANSLATIONS.CURRENCY_CODE]
        || url[QUERY_PARAMETERS_TRANSLATIONS.LANGUAGE]
        || url[QUERY_PARAMETERS_TRANSLATIONS.PROMOTION_CODE]);

    if (shouldSetUrlParams) {
        query = { ...transformOccupancyToUrl(searchParams.occupancy) };
        query[QUERY_PARAMETERS_TRANSLATIONS.CHECKIN] = searchParams.checkIn;
        query[QUERY_PARAMETERS_TRANSLATIONS.CHECKOUT] = searchParams.checkOut;
        query[QUERY_PARAMETERS_TRANSLATIONS.CURRENCY_CODE] = currency ? currency.code : null;
        query[QUERY_PARAMETERS_TRANSLATIONS.LANGUAGE] = language.locale;
    }

    return query;
};

const getPaginationParamsForUrlState = (state, paginationHasChanged) => {
    const { channelSettings, properties, url } = state;

    const query = {};

    const shouldSetPaginationParams = (paginationHasChanged
        || url[QUERY_PARAMETERS_TRANSLATIONS.PROPERTIES_PAGE]
        || url[QUERY_PARAMETERS_TRANSLATIONS.PROPERTIES_PAGE_SIZE]);

    if (channelSettings && channelSettings.multiProperty && shouldSetPaginationParams) {
        query[QUERY_PARAMETERS_TRANSLATIONS.PROPERTIES_PAGE_SIZE] = properties.pagination.pageSize;
        query[QUERY_PARAMETERS_TRANSLATIONS.PROPERTIES_PAGE] = properties.pagination.currentPage;
    }

    return query;
};

const createUrlState = (state, searchParamsHasChanged = false, paginationHasChanged = false) => {
    const { url } = state;

    return {
        ...getCommonParamsForUrlState(url),
        ...getSearchParamsForUrlState(state, searchParamsHasChanged),
        ...getPaginationParamsForUrlState(state, paginationHasChanged),
    };
};

const getCurrentQueryParams = (queryParams) => {
    const query = {};
    getParametersToMaintain().forEach((parameter) => {
        const { name, translation } = QUERY_PARAMETERS[parameter];
        const value = queryParams[translation];
        if (value) {
            query[name] = value !== '' ? value : true;
        }
    });
    const all = Object.assign(query, getOccupancyParams(queryParams));
    const { domain } = queryParams;
    if (domain) {
        all.domain = domain;
    }
    return all;
};

export { getQueryString, createUrlState, getCurrentQueryParams };
